import React from "react";
import { Modal, Table } from "antd";

const SummaryModal = ({ isOpen, onClose, summary }) => {
  // Table data for Consultation Summary
  const consultationData = [
    {
      key: "1",
      label: "Chief Complaint",
      value: summary?.chiefCompliant || "N/A",
    },
    { key: "2", label: "Diagnosis", value: summary?.diagnosis || "N/A" },
    { key: "3", label: "Notes", value: summary?.notes || "N/A" },
    {
      key: "4",
      label: "Management Plan",
      value: summary?.managementPlan || "N/A",
    },
    { key: "5", label: "Allergy", value: summary?.allergy || "N/A" },
    { key: "6", label: "Medication", value: summary?.medication || "N/A" },
    {
      key: "7",
      label: "Surgery History",
      value: summary?.surgeryHistory || "N/A",
    },
  ];

  const columns = [
    { title: "Field", dataIndex: "label", key: "label", width: "30%" },
    { title: "Details", dataIndex: "value", key: "value" },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={900}
      styles={{
        body: {
          padding: "15px 20px",
          maxHeight: "80vh",
          overflowY: "auto",
        },
      }}
      style={{ top: 20 }}
    >
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <img
          src="https://www.germanclinic.ae/_next/image/?url=%2Fassets%2Fimages%2Fmmc-logo.png&w=1920&q=75"
          alt="Hospital Logo"
          style={{ height: "60px", marginBottom: "8px" }}
        />
        <h2 style={{ margin: 0 }}>German Clinic</h2>
        <p style={{ margin: 0 }}>Dubai Healthcare City, Dubai UAE</p>
        <hr />
      </div>

      {/* Patient Details */}
      <div style={{ marginBottom: "15px" }}>
        <h3 style={{ marginBottom: "8px" }}>Patient Details</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            rowGap: "6px",
            columnGap: "10px",
          }}
        >
          <p>
            <strong>Name:</strong> {summary?.patientName || "N/A"}
          </p>
          <p>
            <strong>Age/Gender:</strong> {summary?.patientAge || "N/A"} /{" "}
            {summary?.patientGender || "N/A"}
          </p>
          <p>
            <strong>Patient ID:</strong> {summary?.patientId || "N/A"}
          </p>
          <p>
            <strong>EMR ID:</strong> {summary?.emrId || "N/A"}
          </p>
          <p>
            <strong>Email ID:</strong> {summary?.emailId || "N/A"}
          </p>
          <p>
            <strong>Phone No:</strong> {summary?.phoneNo || "N/A"}
          </p>
        </div>
      </div>

      {/* Consultation Summary */}
      <div style={{ marginBottom: "15px" }}>
        <h3 style={{ marginBottom: "8px" }}>Consultation Summary</h3>
        <Table
          dataSource={consultationData}
          columns={columns}
          pagination={false}
          bordered
          size="small"
        />
      </div>

      {/* Doctor Info */}
      <div style={{ marginTop: "25px", textAlign: "right" }}>
        <p>
          <strong>Dr. {summary?.doctorName || "N/A"}</strong>
        </p>
        <p>
          <strong>Speciality: {summary?.specialityName || "N/A"}</strong>
        </p>
        <p style={{ marginTop: "25px" }}>Signature __________________</p>
      </div>
    </Modal>
  );
};

export default SummaryModal;
